import { getAppLocale } from '../../../utils/app-locale';
import { LICENSE_MODELS, api_base_url } from '../../../constants';
import { API_INSTANCE, API_INSTANCE_NO_CREDENTIALS } from '../../../utils/service-http';
import { appConfiguration } from '../../../utils/app-starter';
import { buildDistributorPDFNewTab, buildReferenceLink } from '../../../utils/url-builder';

const knowMoreLinksCache = {};
const ALL_PRODUCTS = 'all-products';

export function getLicenceCategories (softwareSelection, licenseModel = LICENSE_MODELS.PERPETUAL) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  return API_INSTANCE.post(`${api_base_url}/software-licence-groups/v2?locale=${getAppLocale()}${mainOverrideString}`, {
    softwareSelection,
    licenseModel
  }).then((success) => {
    return success.data.payload;
  }).catch((error) => {
    throw error;
  });
}

export function getKnowMoreLinks(references) {
  return new Promise(async (resolve, reject) => {
    const resultMap = {};
    const productPageLinksMap = {};
    const datasheetLinksMap = {};
    const promiseMaps = [];

    for (const ref of references) {
      if (knowMoreLinksCache[ref] === undefined) {
        const productPageLink = buildReferenceLink(ref);
        const datasheetLink = buildDistributorPDFNewTab(ref);

        promiseMaps.push(
          API_INSTANCE_NO_CREDENTIALS.get(productPageLink, {maxRedirects: 0}).then((res) => {
            if (!res?.request?.responseURL?.includes(ALL_PRODUCTS)) {
              productPageLinksMap[ref] = productPageLink;
            }
          }).catch(err => {})
        );

        promiseMaps.push(API_INSTANCE_NO_CREDENTIALS.get(datasheetLink).then(() => {
          datasheetLinksMap[ref] = datasheetLink;
        }).catch((err) => {}));
      }
    }

    await Promise.allSettled(promiseMaps);
    for (const ref of references) {
      if (knowMoreLinksCache[ref] === undefined) {
        let valueToCache = null;
        if (datasheetLinksMap[ref]) {
          valueToCache = datasheetLinksMap[ref];
        }
        if (productPageLinksMap[ref]) {
          valueToCache = productPageLinksMap[ref];
        }
        knowMoreLinksCache[ref] = valueToCache;
      }

      resultMap[ref] = knowMoreLinksCache[ref];
    }

    resolve(resultMap);
  });
};
